// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const borderWidths = {
    chunky: "8px",
    fat: "4px",
    regular: "2px",
    hairline: "1px",
};
module.exports = borderWidths;
//# sourceMappingURL=borderWidths.js.map